import { observer } from 'mobx-react-lite';
import React, { PropsWithChildren, useEffect } from 'react';
import { Navigate } from 'react-router';
import { useStores } from '../../common/hooks';
import { RoleName } from '../../models';
import { RoutePaths } from '../../route-paths';
import { AccountHaveNoAccessPage } from '../page-account-have-no-access/AccountHaveNoAccessPage';
import NoAccess from './NoAccess';

type FallbackType = 'no-access' | 'no-account' | 'redirect-home';

interface ProtectedRouteProps extends PropsWithChildren {
  allowedRoles: RoleName[];
  accessCheck?: boolean;
  fallback?: FallbackType;
}

const ProtectedRouteImpl: React.FC<ProtectedRouteProps> = (props) => {
  const {
    allowedRoles,
    accessCheck = true,
    fallback = 'no-access',
    children,
  } = props;

  const { userStore } = useStores();

  const hasRole = userStore.isAuthorized(allowedRoles);
  const hasAccess = hasRole && accessCheck;

  useEffect(() => {
    if (hasAccess && allowedRoles.includes('partner')) {
      userStore.setIsShowPartnerPage(true);
    }
  }, [hasAccess, allowedRoles]);

  if (hasAccess) {
    return <>{children}</>;
  }

  switch (fallback) {
    case 'no-account':
      return <AccountHaveNoAccessPage />;
    case 'redirect-home':
      return <Navigate to={RoutePaths.Home} replace />;
    case 'no-access':
    default:
      return <NoAccess />;
  }
};

export const ProtectedRoute = observer(ProtectedRouteImpl);